const releasePeriod = Object.freeze({
  1: 'Daily',
  7: 'Weekly',
  14: 'Bi-weekly',
  28: 'Monthly',
});

export default releasePeriod;
